import { render, staticRenderFns } from "./home-echart.vue?vue&type=template&id=54063722&scoped=true&"
import script from "./home-echart.vue?vue&type=script&lang=js&"
export * from "./home-echart.vue?vue&type=script&lang=js&"
import style0 from "./home-echart.vue?vue&type=style&index=0&id=54063722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54063722",
  null
  
)

export default component.exports